import { render, staticRenderFns } from "./BandejaEmbajadorPendienteRegresarBandejaComponente.vue?vue&type=template&id=001fca51"
import script from "./BandejaEmbajadorPendienteRegresarBandejaComponente.vue?vue&type=script&lang=js"
export * from "./BandejaEmbajadorPendienteRegresarBandejaComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports